import { RootState } from '../../../common/store/store'

export const rcusStates = (state: RootState) => state.rcus
